export default "__VITE_PUBLIC_ASSET__66c60529__"